export enum VoucherType {
  fullAmount = 0,
  fixedAmount = 1,
  fixedRate = 2
}
